export default "__VITE_ASSET__5cbc616d__"